//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            imageLogPropertyJSON: state => state.curtains.imageLogPropertyJSON,
            selectedImageLogProperty: state => state.curtains.selectedImageLogProperty,
        }),
        trimImageLog: {
            get() {
                return this.$store.state.curtains.trimImageLog;
            },
            set(value) {
                this.$store.commit("curtains/updateTrimImageLog", value);
            }
        },
        selectedImageLogProperty: {
            get() {
                return this.$store.state.curtains.selectedImageLogProperty;
            },
            set(value) {
                // value should be an object with _dimension, _name, and _unit
                if (value.hasOwnProperty('_name')){
                    this.$store.commit("curtains/updateSelectedImageLogProperty", value._name);
                } else {
                    console.log("!!! the value does not have the _name property.");
                }
            }
        }
    }
}
